import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  LoginByEmailParams,
  LoginByEmailResponse,
  loginByEmail,
} from '@utils/backend-api/sessions';

export default function useLoginByEmail() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: LoginByEmailParams) => loginByEmail(params),
    {
      onSuccess: (response: LoginByEmailResponse) => {
        const redirectUrl = response.redirectUrl || (response as any).redirectURL;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
